import { ExerciseAssetTypename, LinkAssetTypename, QuizAssetTypename, VideoAssetTypename, ChapterAssetTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService';
export const unwrapLessonChirpError = error => {
  var _error$cause, _error$cause2;
  if (!error) {
    return undefined;
  }
  if (error !== null && error !== void 0 && (_error$cause = error.cause) !== null && _error$cause !== void 0 && (_error$cause = _error$cause.cause) !== null && _error$cause !== void 0 && (_error$cause = _error$cause.cause) !== null && _error$cause !== void 0 && (_error$cause = _error$cause.message) !== null && _error$cause !== void 0 && _error$cause.includes('visibility settings')) {
    return {
      status: 403,
      networkError: Object.assign({
        status: 403
      }, error === null || error === void 0 ? void 0 : error.networkError)
    };
  }
  if (error !== null && error !== void 0 && (_error$cause2 = error.cause) !== null && _error$cause2 !== void 0 && (_error$cause2 = _error$cause2.cause) !== null && _error$cause2 !== void 0 && (_error$cause2 = _error$cause2.cause) !== null && _error$cause2 !== void 0 && (_error$cause2 = _error$cause2.message) !== null && _error$cause2 !== void 0 && _error$cause2.includes('not found')) {
    return {
      status: 404,
      networkError: Object.assign({
        status: 404
      }, error === null || error === void 0 ? void 0 : error.networkError)
    };
  }
  const networkError = error.networkError;
  if (networkError) {
    var _networkError$cause, _networkError$cause2, _networkError$respons, _networkError$respons2;
    const status = networkError.status || networkError.statusCode || ((_networkError$cause = networkError.cause) === null || _networkError$cause === void 0 ? void 0 : _networkError$cause.status) || ((_networkError$cause2 = networkError.cause) === null || _networkError$cause2 === void 0 ? void 0 : _networkError$cause2.statusCode) || ((_networkError$respons = networkError.response) === null || _networkError$respons === void 0 ? void 0 : _networkError$respons.status) || ((_networkError$respons2 = networkError.response) === null || _networkError$respons2 === void 0 ? void 0 : _networkError$respons2.statusCode);
    if (status) {
      return {
        status,
        networkError
      };
    }
    return {
      networkError
    };
  }
  return undefined;
};
export const mapLessonContentTypenameToType = content => {
  switch (content.__typename) {
    case VideoAssetTypename:
      return 'VIDEO';
    case LinkAssetTypename:
      return 'LINK';
    case ExerciseAssetTypename:
      return 'PRACTICAL_EXERCISE_FLOW';
    case QuizAssetTypename:
      return 'QUIZ';
    case ChapterAssetTypename:
      return 'CHAPTER';
    default:
      return undefined;
  }
};